import type { Role } from "~/types/enums";

export const FSPermissions = {
  EVENT_CREATE: "create:event",
  EVENT_EDIT: "edit:event",
  EVENT_DELETE: "delete:event",
  EVENT_REGISTRATION_MANAGEMENT: "event:registration_management",
  EVENT_REGISTER: "event:register",

  GYM_MANAGEMENT: "gym:management",

  ORGANISATION_MANAGEMENT: "organisation:management",
};

export const RolePermissions: Record<Role, string[]> = {
  FIGHTER: [FSPermissions.EVENT_REGISTER],
  GYM_OWNER: [FSPermissions.GYM_MANAGEMENT, FSPermissions.EVENT_REGISTER],
  ORG_OWNER: [
    FSPermissions.EVENT_CREATE,
    FSPermissions.EVENT_EDIT,
    FSPermissions.EVENT_DELETE,
    FSPermissions.EVENT_REGISTRATION_MANAGEMENT,
    FSPermissions.ORGANISATION_MANAGEMENT,
  ],
  REFEREE: [FSPermissions.EVENT_REGISTER],
  VIEWER: [],
};
